'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// translates 2345 => 2,345
var format = function format(price) {
  return Intl.NumberFormat({}).format(price);
};

var CurrentPrice = function CurrentPrice(_ref) {
  var price = _ref.price;
  return _react2.default.createElement(
    'span',
    { id: 'ajaxPrice', className: 'pReg' },
    _react2.default.createElement(
      'span',
      { className: 'price__currency' },
      '$'
    ),
    _react2.default.createElement(
      'span',
      { className: 'price__dollars' },
      format(Math.floor(price))
    ),
    _react2.default.createElement(
      'span',
      { className: 'price__cents' },
      (price % 1).toFixed(2).substring(2)
    )
  );
};

CurrentPrice.propTypes = {
  price: _propTypes2.default.number.isRequired
};

exports.default = CurrentPrice;
//# sourceMappingURL=CurrentPrice.js.map